import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { delay } from 'rxjs/operators';
import { of } from 'rxjs';
import { AuthService } from '../../auth/service/auth.service';
import { CommentsService } from '../service/comments.service';
import { NodesService } from '../service/nodes.service';
import { UserProfileService } from '../../user-profile/service/user-profile.service';
import { NgForm, NgModel } from '@angular/forms';

@Component({
    selector: 'app-node-comments',
    templateUrl: './node-comments.component.html',
    styleUrls: ['./node-comments.component.scss']
})
export class NodeCommentsComponent implements OnInit {
    @Input() node: any; // Passed in from parent component

    @ViewChild('commentForm') commentForm: NgForm;
    @ViewChild('commentBody') commentBody: NgModel;

    newComment: any = { BODY: '' };
    editingThisComment: any = {};
    body_bak = '';
    commentsLimit = 5;

    submittedComment = false;
    submittedEditComment = false;

    user: any;
    isAdding = false;
    isEditing = false;
    isLoading = false;

    constructor(private userProfileService: UserProfileService, private nodesService: NodesService, private commentsService: CommentsService) {}

    ngOnInit(): void {
        this.isLoading = true;
        this.getCurrentUser();
    }

    getCurrentUser() {
        this.userProfileService.getMyProfile().subscribe((res) => {
            if (res?.user) {
                this.user = res.user;

                this.getComments();
            } else if (res?.msg) {
                this.isLoading = false;
            } else {
                this.isLoading = false;
            }
        });
    }

    /** Load comments for this node */
    private getComments(): void {
        this.nodesService.getComments(this.node.ID).subscribe({
            next: (res: any) => {
                if (res.comments) {
                    console.log(res.comments);
                    this.node.NODE_COMMENTS = res.comments;
                } else if (!res.msg.SUCCESS) {
                }
                this.isLoading = false;
            },
            error: () => {
                this.isLoading = false;
            }
        });
    }

    /** Reset the comment form */
    reset(): void {
        this.body_bak = '';
        this.editingThisComment = {};
        this.submittedComment = false;
        this.submittedEditComment = false;
        this.newComment = { BODY: '' };
        this.isAdding = false;
        this.isEditing = false;

        this.commentForm.form.reset();

        // Mimic $timeout($anchorScroll(...)) – here we just simulate a short delay
        of(true)
            .pipe(delay(1))
            .subscribe(() => window.scrollTo({ top: 0, behavior: 'smooth' }));
    }

    /** Create a new comment */
    addComment(valid: boolean): void {
        this.submittedComment = true;
        if (!valid) return;

        this.newComment.NODES_ID = this.node.ID;
        this.commentsService.createComment(this.newComment).subscribe({
            next: (res: any) => {
                if (res.newComment) {
                    this.node.NODE_COMMENTS.push(res.newComment);
                    this.reset();
                } else if (!res?.msg?.SUCCESS) {
                }
            },
            error: () => {}
        });
    }

    /** Delete a comment */
    deleteComment(comment: any): void {
        this.commentsService.deleteComment(comment).subscribe({
            next: (res: any) => {
                if (res?.msg?.SUCCESS) {
                    const idx = this.node.NODE_COMMENTS.indexOf(comment);
                    if (idx >= 0) this.node.NODE_COMMENTS.splice(idx, 1);
                    this.reset();
                } else {
                }
            },
            error: () => {}
        });
    }

    /** Begin editing a comment */
    editComment(comment: any): void {
        // Restore previous editing comment, if any
        if (this.editingThisComment.ID) {
            const idx = this.node.NODE_COMMENTS.indexOf(this.editingThisComment);
            if (idx >= 0) {
                this.node.NODE_COMMENTS[idx].BODY = this.body_bak;
            }
            this.body_bak = '';
            this.editingThisComment = {};
        }

        // Start editing new comment
        this.body_bak = comment.BODY;
        this.editingThisComment = comment;
    }

    /** Cancel editing */
    cancelEdit(): void {
        const idx = this.node.NODE_COMMENTS.indexOf(this.editingThisComment);
        if (idx >= 0) {
            this.node.NODE_COMMENTS[idx].BODY = this.body_bak;
        }
        this.reset();
    }

    /** Save an edited comment */
    saveComment(valid: boolean): void {
        this.submittedEditComment = true;
        if (!valid) return;

        this.commentsService.editComment(this.editingThisComment).subscribe({
            next: (res: any) => {
                if (res.editComment) {
                    const idx = this.node.NODE_COMMENTS.indexOf(this.editingThisComment);
                    if (idx >= 0) this.node.NODE_COMMENTS[idx] = res.editComment;
                    this.reset();
                } else if (!res?.msg?.SUCCESS) {
                }
            },
            error: () => {}
        });
    }

    /** Utility — does this comment belong to the logged-in user? */
    userOwnsComment(comment: any): boolean {
        return this.user?.ID === comment?.LOGIN_DETAILS_ID;
    }

    /** Utility — is this comment currently being edited? */
    isEditingComment(comment: any): boolean {
        return this.editingThisComment?.ID === comment?.ID;
    }
}
